export const VARIANTSFILTER_RECIVE = 'VARIANTSFILTER_RECIVE';
export const VARIANTSFILTER_LOAD_ERROR = 'VARIANTSFILTER_LOAD_ERROR';
export const MEDIAFOLDEREXPLORER_RECIVE = 'MEDIAFOLDEREXPLORER_RECIVE';
export const MEDIAFOLDEREXPLORER_LOAD_ERROR = 'MEDIAFOLDEREXPLORER_LOAD_ERROR';
export const CHECKOUT_RELATEDITEMS_RECIVE = "CHECKOUT_RELATED_ITEMS";
export const CHECKOUT_RELATEDITEMS_LOAD_ERROR = "CHECKOUT_RELATEDITEMS_LOAD_ERROR";
export const UPDATE_CANVAS_SIZE = "UPDATE_CANVAS_SIZE";
export const MENU_OPTION_SELECTED = "MENU_OPTION_SELECTED";
export const CANVAS_OBJECT_ADDED = "CANVAS_OBJECT_ADDED";
export const CANVAS_OBJECT_REMOVED = "CANVAS_OBJECT_REMOVED";
export const CANVAS_OBJECT_COUNT_CHANGED = "CANVAS_OBJECT_COUNT_CHANGED";
export const CANVAS_SELECTION_MODIFIED = "CANVAS_SELECTION_MODIFIED";
export const OBJECT_CHANGED = "OBJECT_CHANGED";
export const CANVAS_FORM_CHANGED = "CANVAS_FORM_CHANGED";
export const CANVAS_HOLES_CHANGED = "CANVAS_HOLES_CHANGED";
export const CANVAS_TYPE_CHANGED = "CANVAS_TYPE_CHANGED";
export const CANVAS_TEXT_PROPERTY_CHANGED = "CANVAS_TEXT_PROPERTY_CHANGED";
export const CANVAS_GUIDE_CURRENT_STEP = "CANVAS_GUIDE_CURRENT_STEP";
export const UNLOCK_CANVAS_EDITING = "UNLOCK_CANVAS_EDITING";
export const LOCK_CANVAS_EDITING = "LOCK_CANVAS_EDITING";

export const OrderStatusType = {
    Init: 'Init',
    Confirmed: 'Confirmed',
};

export const DECAL_EDITOR_SETTINGS_RECEIVE = 'DECAL_EDITOR_SETTINGS_RECEIVE';
export const DECAL_EDITOR_SETTINGS_LOAD_ERROR = 'DECAL_EDITOR_SETTINGS_LOAD_ERROR';

export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR';
export const RESET_CANVAS = 'RESET_CANVAS';
export const CART_QUANTITY_CHANGED = 'CART_QUANTITY_CHANGED';

export const LOAD_SIGN_FOR_EDIT_REQUEST = 'LOAD_SIGN_FOR_EDIT_REQUEST';
export const LOAD_SIGN_FOR_EDIT_SUCCESS = 'LOAD_SIGN_FOR_EDIT_SUCCESS';
export const LOAD_SIGN_FOR_EDIT_ERROR = 'LOAD_SIGN_FOR_EDIT_ERROR';

export const LOAD_EDITOR_TEMPLATE_REQUEST = 'LOAD_EDITOR_TEMPLATE_REQUEST';
export const LOAD_EDITOR_TEMPLATE_SUCCESS = 'LOAD_EDITOR_TEMPLATE_SUCCESS';
export const LOAD_EDITOR_TEMPLATE_ERROR = 'LOAD_EDITOR_TEMPLATE_ERROR';

export const SHOW_PRODUCT_TEMPLATE_EDIT_MODAL = 'SHOW_PRODUCT_TEMPLATE_EDIT_MODAL';
export const EDITOR_TEMPLATE_MODIFIED = 'EDITOR_TEMPLATE_MODIFIED';

export const CANCEL_SIGN_EDITING = 'CANCEL_SIGN_EDITING';
export const INITIALIZE_FROM_SIGN = 'INITIALIZE_FROM_SIGN';

export const UPLOADED_IMAGES = 'UPLOADED_IMAGES';
export const CART_IMAGES = 'CART_IMAGES';

export const CHECKOUT_UPDATE_ORDER_REFERENCE = 'CHECKOUT_UPDATE_ORDER_REFERENCE';

export const UNDO_ACTION = 'UNDO_ACTION';
export const REDO_ACTION = 'REDO_ACTION';
export const HISTORY_STATE = 'HISTORY_STATE';
export const IS_UNDO_REDO_ENABLED = 'IS_UNDO_REDO_ENABLED';
export const SAVE_CANVAS_STATE = 'SAVE_CANVAS_STATE';
export const CLEAR_HISTORY = 'CLEAR_HISTORY';

export const CANVAS_PRICE_CHANGED = 'CANVAS_PRICE_CHANGED';
export const CANVAS_PRICE_RERENDERED = 'CANVAS_PRICE_RERENDERED';

export const WINDOW_RESIZED = 'WINDOW_RESIZED';
export const SNAPPING_TOGGLED = 'SNAPPING_TOGGLED';
